import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppState } from '../../context/AppStateContext';
import TeacherDashboard from '../TeacherDashboard';
import LoadingSpinner from '../common/LoadingSpinner';

const TeacherLandingRedirect = () => {
    const { courses, is_hod, is_head_of_studies, loading } = useAppState();
    
    if (loading) return <LoadingSpinner fullScreen />;

    // For HOS with NO teaching assignments, land on HOS dashboard
    if (is_head_of_studies && (!courses || courses.length === 0)) {
        return <Navigate to="/teacher/hos-dashboard" replace />;
    }

    // For HODs with NO teaching assignments, land on HOD dashboard
    if (is_hod && (!courses || courses.length === 0)) {
        return <Navigate to="/teacher/hod-dashboard" replace />;
    }

    // Default to the general teacher dashboard
    return <TeacherDashboard />;
};

export default TeacherLandingRedirect;
